import constant from "./constant.json";
export const CURRENCY = process.env.REACT_APP_COUNTRY === "USA" ? "$" : "₹";

export const PHONE_CODE = process.env.REACT_APP_COUNTRY === "USA" ? "+1" : "+91";

export const EMPTY_AMOUNT = process.env.REACT_APP_COUNTRY === "USA" ? "$0.00" : "₹0.00";

export function isAmount(value) {
  return /^\d*(\.\d{0,2})?$/.test(value);
}

export function setCookie(name, value) {
  document.cookie = name + "=" + value + ";path=/";
}
export function setCookiePath(name, value) {
  document.cookie = name + "=" + value + ";path=" + window.location.href;
}
export function getCookie(cname) {
  let name = cname + "=";
  let decodedCookie = decodeURIComponent(document?.cookie);
  let ca = decodedCookie.split(";");
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) === " ") {
      c = c.substring(1);
    }
    if (c.indexOf(name) === 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}
export function removeCookie(name) {
  document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
}

// Prevents changing the input value on mouse scroll (works in input type="number")
export const inputScroll = (e) => {
  e.target.blur();
  e.stopPropagation();
  setTimeout(() => {
    e.target.focus();
  }, 0);
};

// Prevents [-, +, e, E] to input
export const blockInvalidChar = (e) => ["e", "E", "+", "-"].includes(e.key) && e.preventDefault();
export function bindDollar(value) {
  const val = value || 0;
  return `${CURRENCY}${Number(val)?.toFixed(2)}`;
}

export function bindCent(value) {
  const val = value || 0;
  return `${CURRENCY}${Number(val)?.toFixed(2)}`;
}

export function countryFilter() {
  return { phoneCode: PHONE_CODE, currency: CURRENCY };
}

export const DateFormat = "MM-dd-yyy";

export const genderOption = [
  { value: "male", label: "Male" },
  { value: "female", label: "Female" },
  { value: "other", label: "Other" }
];
export const RTPOption = [
  { value: "70", label: "70" },
  { value: "80", label: "80" },
  { value: "85", label: "85" },
  { value: "90", label: "90" },
  { value: "95", label: "95" },
  { value: "100", label: "100" }
];
export const statusOptions = [
  { label: "Active", value: "active" },
  { label: "Inactive", value: "inactive" }
];
export const booleanStatusOptions = [
  { label: "Active", value: true },
  { label: "Inactive", value: false }
];
export const statusOptions2 = [
  { label: "Pending", value: "pending" },
  { label: "Active", value: "active" },
  { label: "Inactive", value: "inactive" }
];
export const collectionInvoiceStatus = [
  { label: "Unpaid", value: "unpaid" },
  { label: "Paid", value: "paid" },
  { label: "Forwarded", value: "forwarded" }
];
export const ReferralStatusOptions = [
  { label: "Both", value: "on" },
  // { label: "Off", value: "off" },
  { label: "Sender", value: "sender" },
  { label: "Receiver", value: "received" }
];
export const bonusReferralStatusOptions = [
  { label: "Used", value: "used" },
  { label: "Pending", value: "pending" }
];
export const LoginType = [
  { label: constant.loginType.label.atm, value: "atm" },
  { label: constant.loginType.label.kiosk, value: "kioskTopUp" }
];
export const invoiceStatusOptions = [
  { label: "Estimate", value: "estimate" },
  { label: "Initiated", value: "initiated" },
  { label: "Unpaid", value: "unpaid" },
  { label: "Paid", value: "paid" },
  { label: "Delivered Unpaid", value: "delivered_unpaid" },
  { label: "Completed", value: "completed" }
];
export const kioskStatusOptions = [
  { label: "Created", value: "created" },
  { label: "Selected", value: "selected" },
  { label: "In Stock", value: "inStock" },
  { label: "Sold Out", value: "soldOut" },
  { label: "Returned", value: "returned" }
];
export const kioskStatusOptions2 = [
  { label: "In Stock", value: "inStock" },
  { label: "Returned", value: "returned" },
  { label: "Location", value: "soldOut" }
];
export const typeOptions = [
  { label: "Invoice", value: "invoice" },
  { label: "Return Invoice", value: "return_invoice" }
];
export const format1 = "MM/DD/YYYY";
export const format2 = "MM/DD/YYYY hh:mm A";

export function paymentLabelClass(name) {
  switch (name) {
    case "points":
      return "label-blue";
    case "earning":
      return "label-green";
    case "withdraw":
      return "label-red";
    default:
      return "label-blue";
  }
}

export function statusLabelClass(name) {
  switch (name) {
    case "active":
      return "label-green";
    case "inactive":
      return "label-red";
    case "upcoming":
      return "label-blue";
    case "expired":
      return "label-red";
    case "pending":
      return "label-orange";
    case "estimate":
      return "label-red";
    case "initiated":
      return "label-red";
    case "unpaid":
      return "label-red";
    case "delivered_unpaid":
      return "label-red";
    case "paid":
      return "label-green";
    case "completed":
      return "label-blue";
    case "created":
      return "label-blue";
    case "selected":
      return "label-orange";
    case "inStock":
      return "label-green";
    case "soldOut":
      return "label-red";
    case "return_invoice":
      return "label-red";
    case true:
      return "label-green";
    case false:
      return "label-red";
    case "forwarded":
      return "label-blue";
    default:
      return "label-green";
  }
}

export function userTypeLable(name) {
  switch (name) {
    case "superAdmin":
      return "Super Admin";
    case "superUser":
      return "Super User";
    case "admin":
      return "Distributor";
    case "user":
      return "Distributor User";
    case "operator":
      return "Operator";
    case "operator_user":
      return "Operator User";
    default:
      return "";
  }
}

export function stringAvatar(name = "") {
  if (!name) return;
  if (name.split(" ")[1]) {
    return {
      children: `${name.split(" ")[0][0]}${name.split(" ")[1][0]}`
    };
  } else {
    return {
      children: `${name.split(" ")[0][0]}`
    };
  }
}

export const roundFix = (a) => Math.round(a * 100) / 100;

export function errorMessage() {
  return "Network request failed";
}

export function formatBytes(bytes, decimals = 2) {
  if (!+bytes) return "0 Bytes";

  const k = 1000;
  const dm = decimals < 0 ? 0 : decimals;
  const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];

  const i = Math.floor(Math.log(bytes) / Math.log(k));

  return `${parseFloat(bytes / Math.pow(k, i)).toFixed(dm)} ${sizes[i]}`;
}
export const SUPERACCESS = ["superAdmin", "superUser"];
export const DISTRIBUTORACCESS = ["admin", "user"];
export const OPERATORACCESS = ["operator", "operator_user"];

export function dynamicSort(property) {
  var sortOrder = 1;
  if (property[0] === "-") {
    sortOrder = -1;
    property = property.substr(1);
  }
  return function (a, b) {
    var result = a[property] < b[property] ? -1 : a[property] > b[property] ? 1 : 0;
    return result * sortOrder;
  };
}
export const StatementstatusOptions = [
  { label: "Paid", value: "paid" },
  { label: "Unpaid", value: "unpaid" }
];
export const ChartOptions = [
  { label: "Week", value: "week" },
  { label: "Month", value: "month" },
  { label: "Year", value: "year" }
];
export function uploadProgress(data) {
  return Math.round((100 * data.loaded) / data.total);
}

export const ratioList = [
  { label: "65-70", value: 65 },
  { label: "70-75", value: 70 },
  { label: "75-80", value: 75 },
  { label: "80-85", value: 80 },
  { label: "85-90", value: 85 }
];

export const isEmptyObject = (objectName) => {
  return objectName && Object.keys(objectName).length === 0 && objectName.constructor === Object;
};
export const isEmptyArray = (arrayName) => {
  return Array.isArray(arrayName) && !arrayName.length;
};
export function LabelClass(name) {
  switch (name) {
    case "points":
      return "label-green";
    case "deposit":
      return "label-blue";
    case "withdraw":
      return "label-red";
    default:
      return "label-blue";
  }
}

export const paymentType = [
  {
    value: "points",
    label: "Money"
  },
  {
    value: "earning",
    label: "Earning"
  },
  {
    value: "withdraw",
    label: "Withdraw"
  },
  {
    value: "EtoP",
    label: "Earning to Money"
  }
];
export const paymentSource = [
  {
    value: "atm",
    label: constant.loginType.label.atm
  },
  {
    value: "transfer",
    label: "Transfer"
  },
  {
    value: "bet",
    label: "Bet"
  },
  {
    value: "registration",
    label: "Registration Bonus"
  },
  {
    value: "kioskTopUp",
    label: constant.loginType.label.kiosk
  },
  {
    value: "referral",
    label: "Referral"
  },
  {
    value: "subscription",
    label: "Subscription"
  },
  {
    value: "level",
    label: "Level Bonus"
  },
  {
    value: "dailyWheel",
    label: "DailyWheel Bonus"
  },
  {
    value: "offer",
    label: "Promo Offer"
  },
  {
    value: "scratcher",
    label: "Scratcher Bonus"
  },
  {
    value: "couponCode",
    label: "Coupon Code"
  },
  {
    value: "iap",
    label: "IAP"
  },
  // Coins clawed back after Apple refunded an in-app purchase. Without this entry the
  // transactions page renders " - undefined" for refund rows (pages/transactions/index.js).
  {
    value: "refund",
    label: "Refund"
  }
];

export const discountOptions = [
  { value: "percentage", label: "Percentage (%)" },
  { value: "flat", label: `Flat` },
  { value: "promotional", label: "Promotional" },
  { value: "subscription", label: "Subscription" }
];

export const stringToCountrySlug = (str) => {
  return str
    .trim()
    .toLowerCase()
    .replaceAll(" ", "")
    .replaceAll(".", "")
    .replaceAll("/", "")
    .replaceAll("&", "")
    .replaceAll(/^-+|-+$/g, "");
};

export function capitalizeWords(sentence = "") {
  const words = sentence.split(" ");

  const capitalizedWords = words.map((word) => {
    if (word.length === 0) {
      return "";
    }
    return word.charAt(0).toUpperCase() + word.slice(1);
  });

  return capitalizedWords.join(" ");
}

export const filterOBJ = (obj) => {
  return Object.fromEntries(Object.entries(obj).filter(([_, value]) => value !== ""));
};

export const toLocalISOString = (input) => {
  let date;

  if (input instanceof Date) {
    date = input;
  } else if (typeof input === "string") {
    date = new Date(input);

    if (isNaN(date.getTime())) {
      const match = input.match(/^(\d{1,2})\/(\d{1,2})\/(\d{4})\s+(\d{1,2}):(\d{2})\s*(AM|PM)$/i);

      if (!match) return null;

      let [, mm, dd, yyyy, hh, min, period] = match;

      hh = Number(hh);
      if (period.toUpperCase() === "PM" && hh !== 12) hh += 12;
      if (period.toUpperCase() === "AM" && hh === 12) hh = 0;

      date = new Date(yyyy, mm - 1, dd, hh, Number(min), 0, 0);
    }
  } else {
    return null;
  }

  const pad = (n) => String(n).padStart(2, "0");

  return (
    date.getFullYear() +
    "-" +
    pad(date.getMonth() + 1) +
    "-" +
    pad(date.getDate()) +
    "T" +
    pad(date.getHours()) +
    ":" +
    pad(date.getMinutes()) +
    ":" +
    pad(date.getSeconds()) +
    "." +
    String(date.getMilliseconds()).padStart(3, "0") +
    "Z"
  );
};

export const centToDollar = (cents) => cents / 100 || 0;

export const scratchEventStaticDays = [
  {
    label: "7",
    value: 7
  },
  {
    label: "15",
    value: 15
  },
  {
    label: "30",
    value: 30
  }
];
